import StatusBadge from 'components/atoms/StatusBadge.componen';
import dayjs from 'dayjs';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { InvoiceStatus } from 'types/invoice.types';

export const Status: FC<{
  status: InvoiceStatus;
  dueDate?: string;
}> = ({ status, dueDate }) => {
  const { t } = useTranslation();

  if (status === 'sent') {
    if (dueDate && dayjs().isAfter(dueDate)) {
      return <StatusBadge color="red">{t('overdue')}</StatusBadge>;
    }
    return <StatusBadge color="orange">{t('unpaid')}</StatusBadge>;
  }
  if (status === 'paid') {
    return <StatusBadge color="green">{t('paid')}</StatusBadge>;
  }
  if (status === 'not-sent') {
    return <StatusBadge color="grey">{t('not-sent')}</StatusBadge>;
  }
  return <StatusBadge color="grey">{t('draft')}</StatusBadge>;
};
